// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"266":"914e720b","293":"b5d734d3","654":"9d60d3a4","691":"70eccc05","819":"97dc5072","826":"1b19026d","954":"903de2de"}[chunkId] + ".chunk.css";
};